import { gridGutter, gridGutterHalf, gridGutter1q1dot5 } from "@maxmilhas/hangar-components-atomic/public/styles/components/quarks/layout";
import theme from "../../../../js/shared/new-theme"


export const menu = `
  @media screen and (max-width: 768px) {
	.list-unstyled {
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		margin-bottom: 0;
	
		li {
			&:last-of-type {
				margin-bottom: 0;
			}
		}
  }
}
`
export const listUnstyled = `
	padding-left: 0;
	list-style: none;
`

export const menuList = `
	margin-bottom: ${gridGutter1q1dot5}px;
`
export const pageTitle = `
	font-size: 20px;
	font-weight: bold;
	text-transform: capitalize;
`
export const helloUser = `
  color: ${theme.palette.gray[800].value};
`

const bodyNavItem = `
	line-height: 56px;
	padding-left: 24px;

	@media screen and (max-width: 768px) {
		margin-left: -${gridGutterHalf}px;
		margin-right: -${gridGutterHalf}px;
	  }

	  @media screen and (min-width: 768px) {
		margin-left: -${gridGutter}px;
		margin-right: -${gridGutter}px;
	  }
`

const bodyIcon = `
	i { 
		color: inherit; 
		font-size: 20px;
		vertical-align: sub;
		margin-right: 10px;
	}
	i:before {
		color: inherit; 
	}
`

export const navItem = `
	${bodyNavItem}
	${bodyIcon}
`

export const navLink = `
	color: ${theme.palette.gray[600].value};
	
	&:hover { 
		color: ${theme.palette.gray[900].value};
	}
`

export const selectedNavLink = `
	color: ${theme.palette.primary[800].value};

	&:hover { 
		color: ${theme.palette.primary[800].value};
	}

	&:focus {
		color: ${theme.palette.primary[800].value};
	}

	.navItem:active {
		background-color: ${theme.palette.gray[200].value};
		border-left: 5px solid ${theme.palette.primary[800].value};
	}
`
export const selectedNavItem = `
	${bodyNavItem}

	padding-left: 22px;
	border-left: 5px solid ${theme.palette.primary[800].value};
	
	${bodyIcon}
`